import { c as _c } from "react/compiler-runtime";
import type { DupeKind, DupeKindCount } from '@onefootprint/request-types/dashboard';
import { Filters } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useDupeKindLabels from '../../hooks/use-dupe-kind-labels';
type KindFilterProps = {
  counts: DupeKindCount[];
  selectedKinds: DupeKind[];
  /** Empty means every kind. */
  onChange: (kinds: DupeKind[]) => void;
};
const KindFilter = t0 => {
  const $ = _c(24);
  const {
    counts,
    selectedKinds,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "duplicateData.kindFilter"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const labels = useDupeKindLabels();
  let t2;
  if ($[1] !== counts || $[2] !== labels) {
    let t3;
    if ($[4] !== labels) {
      t3 = t4 => {
        const {
          kind,
          count,
          countCapped
        } = t4;
        return {
          value: kind,
          label: `${labels[kind]} (${count}${countCapped ? "+" : ""})`
        };
      };
      $[4] = labels;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = counts.map(t3);
    $[1] = counts;
    $[2] = labels;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const options = t2;
  let t3;
  if ($[6] !== t) {
    t3 = t(_temp);
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t(_temp2);
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== options || $[11] !== selectedKinds || $[12] !== t4) {
    t5 = [{
      kind: "multi-select",
      label: t4,
      query: "kinds",
      options,
      selectedOptions: selectedKinds
    }];
    $[10] = options;
    $[11] = selectedKinds;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== counts || $[15] !== onChange) {
    t6 = (_, values) => onChange(counts.map(_temp3).filter(kind_1 => [values].flat().includes(kind_1)));
    $[14] = counts;
    $[15] = onChange;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== onChange) {
    t7 = () => onChange([]);
    $[17] = onChange;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t3 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <Filters ariaLabel={t3} controls={t5} onChange={t6} onClear={t7} />;
    $[19] = t3;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default KindFilter;
function _temp($) {
  return $.label;
}
function _temp2($_0) {
  return $_0.label;
}
function _temp3(t0) {
  const {
    kind: kind_0
  } = t0;
  return kind_0;
}